<app-navbar></app-navbar>
<div class="container" style="padding-top: 56px;">
  <wm-register
    [returnApplicationId]="returnApplicationId"
    [invitationId]="invitationId"
  ></wm-register>
</div>
